Wee.fn.make('accordion', {
	init: function() {
		$('ref:title').on('click.accordion', function(e, el) {
			var $el = $(el),
				id = $el.data('id');

			$el.toggleActive();
			$('ref:description-' + id).toggleActive();

			if ($el.hasClass('-active')) {
				$el.attr('aria-expanded', 'true');
			} else {
				$el.attr('aria-expanded', 'false');
			}
		});
	},
	unload: function() {
		$.events.off(null, '.accordion');
	}
});
